import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Where `/` sends an operator.
 *
 * A literal rather than `INTERNAL_PAGES[0].path`, so the route tree type-checks
 * it. A runtime string from the page list would still compile after the route
 * behind it was renamed, and the first sign of that would be a not-found screen
 * on the address every operator opens.
 */
const LANDING_PATH = '/blytzcollect/analytics'

/**
 * The app root redirects rather than drawing a screen.
 *
 * There was a home page here that listed every entry in `INTERNAL_PAGES`. The
 * rail lists the same entries beside it on every route, so the page repeated
 * the navigation an operator had already used to reach it. The rail is now the
 * only navigation, and `/` lands on the first app instead of on a menu.
 *
 * `beforeLoad` rather than a component that navigates on mount: the redirect
 * runs before the route renders, so nothing paints and disappears. `replace`
 * keeps `/` out of the history, so Back leaves the app rather than bouncing
 * off the redirect.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: LANDING_PATH, replace: true })
  }
})
